import { formatTime } from '../../../utils/helpers';
import { Message } from '../../services/patientApi';

export const MessageBubble = ({ msg }: { msg: Message }) => {
  const { content, from_patient, sender_display_name, time } = msg.attributes;
  const formattedTime = formatTime(time);

  if (from_patient) {
    return (
      <div className="flex justify-end">
        <div className="max-w-[70%] w-fit">
          <div className="w-fit ml-auto bg-teamcare-blue text-white rounded-2xl rounded-tr-sm px-4 py-3">
            <p className="text-sm">{content}</p>
          </div>
          <p className="text-[11px] text-secondary-400 mt-1 text-right">
            {sender_display_name} · {formattedTime}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start">
      <div className="max-w-[70%] w-fit">
        <div className="w-fit bg-gray-100 rounded-2xl rounded-tl-sm px-4 py-3">
          <p className="text-sm text-secondary-800">{content}</p>
        </div>
        <p className="text-[11px] text-secondary-400 mt-1">
          {sender_display_name} · {formattedTime}
        </p>
      </div>
    </div>
  );
};
